import { readAnalyticsConsent } from './analyticsConsent';
import { cleanPageUrl, cleanReferrer, clearGaCookies } from './analyticsPrivacy';
import { BROCHURES } from './brochures';

const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const SCRIPT_ID = 'ga4-gtag-script';
const deniedAds = { ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' };
let started = false;
let lastPage = null;

export const isGa4Configured = () => /^G-[A-Z0-9]+$/.test(MEASUREMENT_ID || '');
const permitted = () => started && readAnalyticsConsent() === 'granted';

export const startGa4 = () => {
  if (readAnalyticsConsent() !== 'granted') return false;
  if (!isGa4Configured()) {
    console.error('Google Analytics disabled: missing or invalid REACT_APP_GA4_MEASUREMENT_ID.');
    return false;
  }
  if (started) return true;
  started = true;
  window[`ga-disable-${MEASUREMENT_ID}`] = false;
  window.dataLayer = [];
  window.gtag = function gtag() {
    if (permitted()) window.dataLayer.push(arguments);
  };
  window.gtag('consent', 'default', { analytics_storage: 'denied', ...deniedAds });
  window.gtag('consent', 'update', { analytics_storage: 'granted', ...deniedAds });
  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID, {
    send_page_view: false,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
    ads_data_redaction: true,
    cookie_domain: window.location.hostname,
    cookie_path: '/',
    cookie_expires: 180 * 24 * 60 * 60,
    cookie_update: false,
    page_location: cleanPageUrl(),
    page_referrer: cleanReferrer(),
  });
  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
  script.onerror = () => {
    // Tracking is optional: blockers must never interrupt the main website.
    stopGa4();
  };
  document.head.appendChild(script);
  return true;
};

export const stopGa4 = () => {
  const wasStarted = started;
  started = false;
  lastPage = null;
  if (isGa4Configured()) window[`ga-disable-${MEASUREMENT_ID}`] = true;
  const script = document.getElementById(SCRIPT_ID);
  if (script) { script.onerror = null; script.remove(); }
  if (window.dataLayer) window.dataLayer.length = 0;
  if (window.gtag) window.gtag = () => {};
  clearGaCookies();
  return wasStarted;
};

export const trackPageView = () => {
  if (!permitted()) return false;
  const url = cleanPageUrl();
  if (lastPage === url) return false;
  lastPage = url;
  window.gtag('event', 'page_view', {
    send_to: MEASUREMENT_ID, page_title: document.title,
    page_location: url, page_referrer: cleanReferrer(),
  });
  return true;
};

export const trackBrochureClick = (audience) => {
  if (!permitted() || !Object.prototype.hasOwnProperty.call(BROCHURES, audience)) return false;
  const brochure = BROCHURES[audience];
  window.gtag('event', 'brochure_download', {
    send_to: MEASUREMENT_ID, audience, brochure_name: brochure.name,
    brochure_path: brochure.path, page_location: cleanPageUrl(), page_referrer: cleanReferrer(),
  });
  return true;
};